export default "__VITE_ASSET__yf8zc3ay__"